import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';

export const conversationPaneStyles = StyleSheet.create({
	// Muted inline notice for a degraded timeline (e.g. the activity-events endpoint is down).
	// Deliberately quiet — the conversation itself still renders and stays usable.
	timelineNotice: {
		color: THEME.colors.text.light,
		fontSize: 12,
		padding: `${THEME.spacing.xs}px ${THEME.spacing.sm}px`,
		textAlign: 'center',
	},
	threadArea: {
		flex: 1,
		minHeight: 0,
		overflowY: 'auto',
		padding: '8px 16px',
		display: 'flex',
		flexDirection: 'column',
		// No flex gap: each ThreadItem/EventItem already supplies its own marginBottom
		// (styles.thread). A gap here would stack on top of that margin and double the
		// space between messages — let the bubble margin be the single source of spacing.
		gap: 0,
	},
	// Keep the final thread above the absolutely positioned collapsed composer.
	threadAreaFloatingComposer: {
		paddingBottom: 60,
	},
	composerHost: {
		flexShrink: 0,
	},
});
